import styled from 'styled-components';

// copy from web legacy in build.css
const ConnectFacebookWrapper = styled.div`
  .boarding-in.facebook .boarding-button-back {
    left: 0;
  }

  .boarding-fb {
    display: block;
    width: 120px;
    height: 120px;
    margin-bottom: 20px;
    margin: auto;
    border-radius: 50%;
    overflow: hidden;
    background: #eee no-repeat center center / 51px auto
      url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAYAAAA6oTAqAAAACXBIWXMAAAsSAAALEgHS3X78AAADhklEQVRo3uVa0W3iQBB9oPyHVICvgriDkAqgA7jvjBRSQbgOfNL8ByqIU0FMB9AB6QAq4H7eXkY+g9dk10TcShYysnf9PDNv3zzo7Pd7XMro4oLG1ak3ikgPQGq+Wqnq9pxgOk3STERGANxxXXHJB4ACwFxVi28JhiAyAP0Gc38AmLQJqluXSiKSA3g1QNYAngDcA7hR1Q6AG57/Igjw+ncRyc4eGdZEAeDWgJj6vGkRGQCYl17AIHZNdT2B/FbV1DdleF0KYMGvbgnuLGk2M0B+quq06cSqulXViQE0FJFZq2nGFHnn6YIP9KXBuhvy9IeqbtqKzMyw0TTQOhMAu9L8ccGISALgzi0aqmA5j2O1MWsyemRG/NypauiCzSrWaQVMHnohRmfJ00EbYBKnsyKldVFaJyqYfmQw/3cLICIpteHJYJJvhKcA8CoiaVMwrkDTSA/m5m1C+a7V6DUFs4rJNmbeVRs149jm1iesDXPfNnR5dDCqmpt+JLTscNJoraqtRAZGqg99WcQjKlMjk6I1a92KnXrGZgoA5l9NN97voryMIJNqqdmp3GsAxamAeF/BeXac9yxt8wTAixOeVNFZAyAzAM/m/kG5VqjS6/Y011s91bDg9qg7w0YtNyz0wZTJq9oDPtyIxd73ALJCtWUVx2rionNTwDAmxbakGspW1Bvtpu2BuecAxoGw7LxNQEZpatrfY2OBQEagiLgHvK+bz9ue5UQFu8TBAclT4Iw2bWOvmQ+ax9rFL7oFCB6ZUmo5sXhXcemSpLACULRtnl95iMOJZ9FbgEMAzyKyYzpmsfRYLRgyV4ZPV9PS8QrAhp9lak4YvZQ0fU3qHYvIkjS9aQ0MXfvHEoDs0EZZsz9NePQZtZWITGPps7/7DOsiN6kS7PcVSqPM7Pbeti831hGAtC6qls0yA2TBm4MUMCORGDU+9jXRCTr1Sc/Ofr8vi8ogZvmRN21N9PuQjNctdZXLmEBMexGlm+2SfvtmoaiDJOJA3IX0GrpGY61j0mZFDe1CO0GWANoWhxtfP6zJPrM1IZ9xt95GJICktCEHy4bOw8ND+cdYJ0FyWk8hAPTw+WcIK42CMqej5h6L8vGAeLQSBgA2VfXFYu7xSI28Kcuixp5C47a5QoKEHm8m6sFT+Zg7kxjZnx7o8Y+NtYlmKx1o55T/m5l0+oeh2qL3YGC+67iotvkPTTenKu8H9gUAAAAASUVORK5CYII=');
  }

  .boarding-button {
    display: inline-block;
    margin-top: 20px;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    border-radius: 2px;
    background: #00ab6b;
    color: #fff;
    cursor: pointer;
    transition: all 0.1s cubic-bezier(0.98, 0.01, 1, 1);
  }

  .boarding-button.fb {
    background: #3b5998;
  }

  .boarding-button:hover {
    background: #333;
  }
`;

export default ConnectFacebookWrapper;
